import React from "react";
import ViewChangeKeyPositionCertificateCoOrdinator from "../../features/ViewChangeKeyPositionCertificateCo-ordinator/ViewChangeKeyPositionCertificateCo-ordinator";
import "./ViewChangeKeyPositionCertificate.scss";

const ViewChangeKeyPositionCertificateCoordinatorpage = () => {
  return (
    <div className="page-container">
      <ViewChangeKeyPositionCertificateCoOrdinator />
    </div>
  );
};

export default ViewChangeKeyPositionCertificateCoordinatorpage ;
